
export const BACKGROUND_COLOR = '#ffffff';
export const BORDER_COLOR = '#dddddd';
export const DULL_TEXT_COLOR = '#dddddd';
export const DULL_TEXT_COLOR_DARKER = '#777777';
export const PRIMARY_BUTTON_BACKGROUND_COLOR = '#473FA2';
export const LIGHT_BACKGROUND_COLOR = '#f5f5f5';
export const TEXT_COLOR = '#000000';


export const CONTRACT_ADDRESS = "0x974bc7bA0DBce8292179866Ad9f68c237e9F31dc";

export const INFURA_ID = 'c2a8fd67f6d64e04ba145d40d50e021b';
export const INFURA_URL = `https://polygon-mainnet.infura.io/v3/${INFURA_ID}`;

export const CHAIN_ID = 137;
export const CHAIN_HEX = '0x89';

export const CHAIN_NAME = 'Polygon';
export const CHAIN_EXPLORER = "https://polygonscan.com/#";
